// Pure logic for the "Select State, City, Area" card of Add Book Distribution.
// Book distribution is recorded against a route place's recorded city visit, so
// State, City and Area are never typed here: they come from that visit (its
// location's state/city, and the areas saved with it in Record Visit).
import { formatDate } from "../../utils/tspFormat";

export const stateOf = (visit) => visit?.location?.state_name || "";

const sortKey = (visit) => `${visit.visit_date || ""} ${visit.visit_time || ""}`;

// Newest visit first (date, then time, then id), like the City Visits history.
export function sortVisitsNewestFirst(visits) {
  return [...visits].sort((a, b) => sortKey(b).localeCompare(sortKey(a)) || Number(b.id) - Number(a.id));
}

// The states that have at least one recorded visit, A–Z.
export function stateOptions(visits) {
  return [...new Set(visits.map(stateOf).filter(Boolean))].sort((a, b) => a.localeCompare(b));
}

export function visitsInState(visits, stateName) {
  return visits.filter((visit) => stateOf(visit) === stateName);
}

// Which visit to pre-select. Coming from a route place (?journey=&location=):
// that place's most recent visit, or none if it has not been visited yet (the
// page then asks for the visit to be recorded first, rather than silently
// picking another city). Otherwise: the most recent visit of the given journey,
// or of any journey. `visits` must already be newest first.
export function pickDefaultVisit(visits, { journeyId, locationId } = {}) {
  const inJourney = journeyId ? visits.filter((visit) => String(visit.journey?.id) === String(journeyId)) : visits;
  if (locationId) return inJourney.find((visit) => String(visit.location?.id) === String(locationId)) || null;
  return inJourney[0] || null;
}

// "Fort, Market" — the areas recorded with the visit.
export function areaText(visit) {
  return (visit?.areas_visited || []).join(", ");
}

// A City option: the city and visit date, plus the journey when visits of more
// than one journey are on offer (two journeys can visit the same city).
export function cityOptionLabel(visit, showJourney) {
  const city = visit.location?.city_name || visit.location?.label || "City";
  const base = `${city} — ${formatDate(visit.visit_date)}`;
  return showJourney && visit.journey?.journey_name ? `${base} (${visit.journey.journey_name})` : base;
}
